import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center">
      <div className="samaaj-card p-10">
        <XCircle size={48} weight="fill" className="mx-auto text-[#D95A41]" />
        <h1 className="font-heading text-4xl mt-4">Checkout cancelled</h1>
        <p className="text-[#5C564D] mt-2">No worries — the item is still available.</p>
        <Link to="/marketplace" data-testid="back-marketplace-cancel" className="samaaj-btn-primary mt-6 inline-block">Return to Marketplace</Link>
      </div>
    </div>
  );
}
